import styled from 'styled-components';

export const StyledLanguageToggle = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
 
  @media screen and (max-width: ${({ theme }) => theme.sizes.lg}) {
    display: none;
  }
`;

export const StyledLanguageIcon = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  
  svg {
    height: 2rem;
    width: 2rem;

    path {
      fill: ${({ theme }) => theme.colors.alpha[50]};
    }
  }

  &:hover {
    svg path {
      fill: ${({ theme }) => theme.colors.alpha[75]};
    }
  }

  &:active {
    svg path {
      fill: ${({ theme }) => theme.colors.white};
    }
  }

  &:focus,
  &:focus-visible {
    outline: none;
  }
  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    padding-right: 1rem;
  }
`;

export const StyledDropdown = styled.div<{ isOpen: boolean }>`
  position: absolute;
  top: 100%;
  z-index: 1000;
  right: 0;
  min-width: 150px;
  background: #212C42;
  border-radius: 5px;
  box-shadow: 0px 3px 13px 0px #151C2B12;
  opacity: ${({ isOpen }) => (isOpen ? 1 : 0)};
  visibility: ${({ isOpen }) => (isOpen ? 'visible' : 'hidden')};
  transform: translateY(${({ isOpen }) => (isOpen ? '4px' : '0')});
  transition: all 0.2s ease-in-out;
  margin-top: 4px;
  padding: 0.8rem;
  border: 1px solid #3E475A;
`;

export const StyledLanguageOption = styled.button<{ isSelected: boolean }>`
  width: 100%;
  display: flex;
  align-items: center;
  align-content: center;
  padding: 1rem;
  border: none;
  background: ${({ isSelected }) => (isSelected ? '#3E475A' : 'transparent')};
  color: #EEEFF2;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
  border-radius: 6px;
  font-size: 16px;

  &:hover {
    background: #3E475A;
  }

  &:first-child {
    margin-bottom: 0.5rem;
  }

`;
